<template>
<div class="ui-select form-control" :class="{open: selectOpen}">
	<div ref="toggle" @mousedown.prevent="toggleSelect" class="select-toggle clearfix">
		<span class="selected-tag" v-if="searchTextPlaceholder" ref="searchtext" v-html="searchTextPlaceholder"></span>
		<input
            ref="search"
            v-model="search"
            @keyup.esc="onEscape"
            @keydown.up.prevent="typeAheadUp"
            @keydown.down.prevent="typeAheadDown"
            @keydown.enter.prevent="typeAheadSelect"
            @blur="onSearchBlur"
            @focus="onSearchFocus"
            type="search"
            class="form-control"
            autocomplete="off"
            :placeholder="searchPlaceholder"
            :id="inputId"
            aria-label="Search for option"
      	>
      	<i ref="openIndicator" class="open-indicator"></i>
	</div>
	<ul ref="selectOption" v-if="selectOpen" class="select-option" :style="{ 'max-height': maxHeight }">
		<li v-for="(option, index) in filterOptions" :key="index" :class="{ highlight: index === selectIndex, active: val && getValue(option) === val }" @mouseover="selectIndex = index">
			<a @mousedown.prevent="select(option)" v-html="getOptionLabel(option)"></a>
		</li>
		<li v-if="!filterOptions.length" class="no-options">未找到结果</li>
	</ul>
</div>
</template>

<script>
	export default {
		name: 'selects',
		props: {
			options: {
				type: [Object, Array]
			},
			val: {
				default: ''
			},
			valueKey: {
				default: null
			},
			placeholder: {
				type: String,
        		default: ''
			},
			inputId: {
        		type: String
      		},
      		label: {
        		type: String,
        		default: 'label'
      		},
      		maxHeight: {
        		type: String,
        		default: '400px'
      		}
		},
		computed: {
			filterOptions () {
				if (this.search.length) {
					return this.options.filter((option) => {
						let label = this.getOptionLabel(option)
	            		if (typeof label === 'number') {
	              			label = label.toString()
	            		}
                        console.log(label);
                        if (label) {
	            		    return label.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                        } else {
                            return false;
                        }
					})
				}
				
				return this.options
			},
			searchPlaceholder () {
				if (this.objIsEmpty(this.selected) && this.placeholder && !this.search) {
					return this.placeholder
				}
			},
			searchTextPlaceholder () {
				if (!this.search) {
					return this.searchText
				}
			}
		},
		methods: {
			toggleSelect (e) {
				if (e.target === this.$refs.search || e.target === this.$refs.toggle || e.target === this.$refs.searchtext || e.target === this.$refs.openIndicator) {
					if (this.selectOpen) {
						this.$refs.search.blur()
					} else {
						this.selectOpen = true
						this.$refs.search.focus()
					}
				}
			},
			onEscape () {
		        if (!this.search.length) {
		          	this.$refs.search.blur()
		        } else {
		          	this.search = ''
		        }
	      	},
	      	onSearchBlur () {
	      		this.search = ''
	      		if (this.objIsEmpty(this.selected)) {
	      			this.searchText = ''
	      		} else {
	      			this.searchText = this.getOptionLabel(this.selected)
	      		}
	      		
        		this.selectOpen = false
        		this.$emit('search:blur')
	      	},
	      	onSearchFocus () {
	      		this.selectOpen = true
        		this.$emit('search:focus')
	      	},
	      	getOptionLabel (option) {
	      		if (this.label && option[this.label]) {
	      			return option[this.label]
	      		}

	      		return option
	      	},
	      	getValue (option) {
	      		if (this.valueKey && option[this.valueKey]) {
	      			return option[this.valueKey]
	      		}

	      		return option
	      	},
	      	select (option) {
	      		this.selected = option
         		this.$refs.search && this.$refs.search.blur()
         		this.searchText = this.getOptionLabel(option)
	      	},
	      	typeAheadUp () {
	      		if (this.selectIndex > 0) {
	      			this.selectIndex--
	      			this.setOptionScroll()
	      		}
	      	},
	      	typeAheadDown () {
	      		if (this.selectIndex < this.filterOptions.length - 1) {
	      			this.selectIndex++
	      			this.setOptionScroll()
	      		}
	      	},
	      	typeAheadSelect () {
	      		if (this.filterOptions.length) {
	      			this.select(this.filterOptions[this.selectIndex])
	      		}
	      	},
	      	setOptionScroll () {
	      		let wrapEle = this.$refs.selectOption
	      		let eleHeight = wrapEle.children[this.selectIndex].offsetHeight

	      		let eleTop = 0
	    		for (let i = 0; i < this.selectIndex; i++) {
	    			eleTop += wrapEle.children[i].offsetHeight
	    		}

	    		if (eleTop <= wrapEle.scrollTop) {
	    			wrapEle.scrollTop = eleTop
	    		} else if (eleTop + eleHeight >= wrapEle.offsetHeight) {
	    			if (!wrapEle.scrollTop) {
	    				wrapEle.scrollTop = Math.ceil((eleTop + eleHeight - wrapEle.offsetHeight) / eleHeight) * eleHeight
	    			} else {
	    				wrapEle.scrollTop = wrapEle.scrollTop + eleHeight
	    			}
	    		}
	      	},
	      	setValue () {
	      		this.options.forEach((option, index) => {
					if (this.getValue(option).toString() === this.val.toString()) {
						this.selectIndex = index
						this.select(option)
					}
				})
	      	}
		},
		watch: {
			selected (val) {
				this.$emit('onChange', val)
				this.$emit('input', this.getValue(val))
			},
			selectOpen (val) {
				if (val && this.selectIndex > 0) {
					this.$nextTick(() => {
						this.setOptionScroll()
					})
				}
			},
			options (val, oldVal) {
				if (this.val && !oldVal.length) {
					this.setValue()
				}
			},
			val (val, oldVal) {
				if (this.options.length && !oldVal.length) {
					this.setValue()
				}
			}
		},
		data () {
			return {
				search: '',
				searchText: '',
				selectOpen: false,
				selectIndex: -1,
				selected: {}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/select/select.vue